import React, {Component} from 'react';
import {connect} from "react-redux";

class MiddlewareStatus extends Component {

    render() {
        let status = null;

        if (!this.props.running) {
            status = (<span>
                {window.eidMessages.middlewareRequired}
                <br/><br/>
                {this.props.versions.map(ver => <div><a href={ver.download_url} target="_blank" rel="noopener noreferrer">{window.eidMessages.downloadMiddleware + ' (' + ver.os + ')'}</a></div> )}
                <br/><br/>
                {window.eidMessages.faqInfo} <a href={window.eidMessages.faqUrl} target="_blank" rel="noopener noreferrer">{window.eidMessages.visitFaq}</a>
            </span>)
        }

        return (
            <div id="middleware-status">
                {status}
            </div>
        )
    }

}

export default connect(
    (state) => {
        return {
            running: state.eid.middlewareRunning,
            versions: state.eid.versions
        }
    },
    (dispatch) => {
        return {

        }
    }
)(MiddlewareStatus);


// WEBPACK FOOTER //
// ./src/components/MiddlewareStatus.js